/* global axios */
import ApiClient from './ApiClient';

class DealAPI extends ApiClient {
  constructor() {
    super('deals', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(deal) {
    return axios.post(this.url, deal);
  }

  update(id, deal) {
    return axios.patch(`${this.url}/${id}`, deal);
  }

  delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  kanban(pipelineId) {
    return axios.get(`${this.url}/kanban`, {
      params: { pipeline_id: pipelineId },
    });
  }

  search(query, page = 1) {
    return axios.get(`${this.url}/search`, {
      params: { q: query, page },
    });
  }

  moveStage(id, stageId) {
    return axios.post(`${this.url}/${id}/move_stage`, {
      stage_id: stageId,
    });
  }

  activities(dealId) {
    return axios.get(`${this.url}/${dealId}/activities`);
  }
}

export default new DealAPI();
